import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles } from "lucide-react";
export function CTASection() {
  return <section className="py-20 bg-foreground relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-wellness-teal rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-wellness-warm rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          

          <h2 className="font-display text-3xl md:text-5xl font-bold text-background mb-6">
            Ready to Transform Your{" "}
            <span className="text-primary">Wellness Journey?</span>
          </h2>

          <p className="text-lg text-background/70 mb-10 max-w-2xl mx-auto">
            Whether you're looking for the perfect spa treatment or want to grow your wellness business, 
            Wellness Connect is here to help you succeed.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button variant="hero" size="xl" asChild>
              <Link to="/browse">
                Find Wellness Services
                <ArrowRight className="w-5 h-5 ml-2" />
              </Link>
            </Button>
            <Button variant="glass" size="xl" className="border-background/20 text-background hover:bg-background/10" asChild>
              <Link to="/register">
                List Your Business
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}